import {
  AUTH_NOTIFICATION,
  AUTH_SET_LOADING,
  SINGLE_USER,
  FORGET_LOADER,
} from "../types";

const initialState = {
  notification: {
    message: "",
    type: "",
  },
  singleUser: [],
  singleUserLoader: false,
  loading: false,
  forgetLoading: false,
};

export default function authReducer(state = initialState, { type, payload }) {
  switch (type) {
    case AUTH_NOTIFICATION:
      return {
        ...state,
        notification: payload,
      };
    case AUTH_SET_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case SINGLE_USER:
      return {
        ...state,
        singleUser: payload,
      };

    case "SINGLE_USER_LOADER":
      return {
        ...state,
        singleUserLoader: payload,
      };
    case FORGET_LOADER:
      return {
        ...state,
        forgetLoading: payload,
      };

    default:
      return {
        ...state,
      };
  }
}
